import { Component, Inject, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { SessionService, DialogManagerService } from '@src/services';
import { actionClick, getEditProject, setEditMode } from '@src/store/actions/project-actions';
//import { projectsActions } from "../../../store/reducers/projectsReducer";
@Component({
    selector: 'edit-mode',
    template: require('./edit-mode.component.html'),
    styles: [require('./edit-mode.component.scss')]
})
export class EditModeComponent implements OnInit, OnDestroy {
    public hideManageEnv = 'false';
    public isEditMode: boolean;
    public menuExpanded = false;
    public isParentIdExist: boolean;

    private unSubscribe: any;
    private prevState: any;
    private draftProjectSaved: boolean;
    private toClose: boolean;

    constructor(
        private store: Store,
        private sessionService: SessionService,
        private dialogManagerService: DialogManagerService,
        @Inject('$scope') private $scope: any,
        @Inject('$rootScope') private $rootScope: any,
        @Inject('$state') private $state: any,
        @Inject('$state') private $stateParams: any) {
        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().project.editMode) {
                this.isEditMode = true;
                this.menuExpanded = false;
            } else {
                this.isEditMode = false;
                this.hideManageEnv = 'false';
            }
            if (this.store.getState().project.hideManageEnv && this.$state.current.name === 'app.authorized.environments') 
            {
                this.hideManageEnv = this.store.getState().project.hideManageEnv;
            } 
            else if (this.$state.current.name !== 'app.authorized.environments' && this.$state.current.name !== 'app.authorized.projects') 
            {
                this.hideManageEnv = 'true';
            }
            if(this.store.getState().project && this.store.getState().project.data && this.store.getState().project.data.parentId)
                this.isParentIdExist = true;
            else
                this.isParentIdExist = false;
        });
    }

    public ngOnInit() {
        this.$rootScope.$on('$stateChangeSuccess', (_: any, __: any, toParams: any, fromState: any) => {
            const projectState = this.store.getState().project;
            if (projectState && projectState.editMode && toParams.fromContext) {
                this.prevState = fromState;
            }
        });
        this.$rootScope.$on('$viewContentLoaded', () => {
            if (this.isEditMode && !this.toClose && this.$state.params.name == '') {
                this.store.dispatch(setEditMode(true));
                let isNew = false;
                // create draft project
                this.store.dispatch(getEditProject(this.$stateParams.id, (response: any) => {
                    isNew = response.data.isNew;
                    if (this.$stateParams.id == this.store.getState().projects.projectWithMetaData.id
                        && !this.store.getState().projects.projectWithMetaData.isDraft) {
                        this.sessionService.set(`project_${response.data.id}`, `${response.data.name} (Draft)`);
                        const nextState = this.$state.current.name === 'app.authorized.configurationsView'
                            ? this.$state.current.name
                            : 'app.authorized.environments';
                        this.$state.go(nextState, {
                            id: response.data.id,
                            name: `${response.data.name} (Draft)`,
                            isNewDraft: response.data.isNew
                        });
                    }
                    this.store.dispatch(setEditMode(true, isNew));
                }));
            }
        });

        // exit from edit mode to other state
        this.$scope.$on('$stateChangeStart', (event: any, toState: any, toParams: any, _: any, fromParams: any) => {
            if (!this.draftProjectSaved && this.store.getState().project.editMode) {
                this.toClose = true;
                switch (toState.name) {
                case 'app.authorized.packages':
                    this.hideManageEnv = 'true';
                    break;
                case 'app.authorized.configurationsView':
                    this.hideManageEnv = 'true';
                    break;
                case 'app.authorized.taskManager':
                    this.hideManageEnv = 'true';
                    break;
                case 'app.authorized.environments': // must be last
                    if (toParams && fromParams && fromParams.id == toParams.id || (!fromParams.id)) {
                        this.hideManageEnv = 'false';
                        break;
                    }
                    //if the ids are different it means you publish a project and should not go to default
                    else if (toParams && fromParams && (fromParams.id != toParams.id || (!fromParams.id)) && (toParams.name + " (Draft)"=== fromParams.name))
                    {
                        break;
                    }
                default:
                    setTimeout(() => { this.showExitEditingModeDialog(toState, toParams); }, 10);
                    event.preventDefault();
                }
            } else {
                switch (toState.name) {
                case 'app.authorized.packages':
                case 'app.authorized.configurationsView':
                case 'app.authorized.taskManager':
                case 'app.authorized.environments':
                    return;
                default:
                    this.draftProjectSaved = false;
                    this.store.dispatch(setEditMode(false));
                }
            }
        });
    }

    public ngOnDestroy() {
        this.unSubscribe();
    }

    public manageEnvTypes() {
        this.store.dispatch(actionClick('manageEnv', this.$state));
    }

    public undoChanges() {
        this.store.dispatch(actionClick('undo', this.$state));
        this.draftProjectSaved = false;
        if (this.prevState) {
            this.$state.go(this.prevState.name);
            this.prevState = null;
        }
    }

    public saveChanges() {
        this.store.dispatch(actionClick('saveChange', this.$state));
    }

    public saveDraft() {
        this.draftProjectSaved = true;
        this.store.dispatch(actionClick('saveDraft', this.$state));
    }

    private showExitEditingModeDialog(toState: any, toParams: any) {
        const dialogData = {
            title: 'Exit editing mode',
            text: 'Editing mode is on, do you want to leave it and discard all changes?',
            hasConfirm: true,
            confirmText: 'Exit & discard changes',
            cancelText: 'Continue edit'
        };
        const onConfirm = () => {
            this.undoChanges();
            this.store.dispatch(setEditMode(false));
            this.$state.go(toState, toParams);
        };
        // TODO windowClass: 'editMode-modal-window',
        this.dialogManagerService.showTimeoutDialog(dialogData, onConfirm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/edit-mode/edit-mode.component.ts